import { useQuery } from '@tanstack/react-query';
import { httpService } from '../../../utils/apiService';

export const useGetSapLogs = ({ params, options = {} }) => {
  return useQuery({
    queryKey: ['SapLogs', params],
    queryFn: async () => {
      const queryParams = new URLSearchParams();
      Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value);
        }
      });

      const response = await httpService.post(
        `sap-logs/list?${queryParams.toString()}`,
        params
      );
      return response?.data?.data;
    },
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useGetSapLogDetail = (id, { operatorId, ...options } = {}) => {
  return useQuery({
    queryKey: ['SapLogDetail', id, operatorId],
    queryFn: async () => {
      const query = operatorId
        ? `?operatorId=${encodeURIComponent(operatorId)}`
        : '';
      const response = await httpService.get(`sap-logs/${id}${query}`);
      return response?.data?.data;
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
    ...options,
  });
};
